<template>
  <vip-sonko-layout>
    <v-layout wrap>
      <v-toolbar flat color="toolbarColor" dense class="mx-3">
        <v-toolbar-title class="title">Job Details</v-toolbar-title>
        <v-spacer></v-spacer>
      </v-toolbar>
      <!-- job details -->
      <job-details :job="job" :media="media"></job-details>
      <!-- end -->
    </v-layout>
  </vip-sonko-layout>
</template>

<script>
import JobDetails from '../_components/more_details';
import { mapGetters } from 'vuex';

export default {
    name: 'JobDetailsPage',
    components: {
      JobDetails
    },
    computed: {
      ...mapGetters(["host"])
    },
    data() {
      return {
        job: {},
        media: [],
      }
    },
    methods: {

    },
    created() {
      const id = this.$route.params.id;
      if(id!==undefined){
        this.$store.dispatch("get", '/job/'+ id).then(res => {
        this.job = res.job;
        this.job.images.forEach(image => {
          this.media.push({
              thumb: `${this.host}/uploads/jobs/${image}`,
              src: `${this.host}/uploads/jobs/${image}`,
            })
        });
      });
      }
    }
}
</script>
